module.exports = __webpack_public_path__ + "static/media/p_34_0.09ccd595.png";